import Lottie from 'lottie-react';
import LottieView from 'lottie-react-native';
import React, { useEffect, useState } from 'react';
import { Platform } from 'react-native';
import confettiAnimation from '../assets/confetti.json';

interface ConfettiAnimationProps {
  shouldShow: boolean;
  onAnimationComplete?: () => void;
}

export const ConfettiAnimation: React.FC<ConfettiAnimationProps> = ({ 
  shouldShow, 
  onAnimationComplete 
}) => {
  const [confettiKey, setConfettiKey] = useState(0);
  const [showConfetti, setShowConfetti] = useState(false);

  useEffect(() => {
    if (shouldShow) {
      // Force confetti to restart when component mounts
      setShowConfetti(false);
      const timer = setTimeout(() => {
        setConfettiKey(prev => prev + 1);
        setShowConfetti(true);
      }, 100);
      
      return () => clearTimeout(timer);
    } else {
      setShowConfetti(false);
    }
  }, [shouldShow]);

  if (!showConfetti) return null;

  if (Platform.OS === 'web') {
    return (
      <Lottie
        key={`confetti-${confettiKey}`}
        animationData={confettiAnimation}
        loop={false}
        autoplay={true}
        onComplete={onAnimationComplete}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 10,
          pointerEvents: 'none',
          width: '100%',
          height: '100%',
        }}
      />
    );
  }

  return (
    <LottieView
      key={`confetti-${confettiKey}`}
      source={confettiAnimation}
      loop={false}
      autoPlay={true}
      onAnimationFinish={onAnimationComplete}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 10,
        pointerEvents: 'none',
        width: '100%',
        height: '100%',
      }}
    />
  );
};
